import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-499ec4a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "InvoiceDocumentHeader" }
const _hoisted_2 = { class: "InvoiceDocumentHeader__number" }
const _hoisted_3 = { class: "InvoiceDocumentHeader__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.number), 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1)
  ]))
}